
<table mat-table [dataSource]="items" class="mat-elevation-z1 responsive-table-desktop" style="width: 100%;">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef>#</th>
    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Nome</th>
    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
  </ng-container>

  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>Email</th>
    <td mat-cell *matCellDef="let element"> {{element.email}} </td>
  </ng-container>

  <ng-container matColumnDef="mobile">
    <th mat-header-cell *matHeaderCellDef>Telefone</th>
    <td mat-cell *matCellDef="let element"> {{api.nineExtra(element.mobile) | mask: api.phoneMask}} </td>
  </ng-container>

  <ng-container matColumnDef="options">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        color="primary"
        aria-label="Select the business"
        (click)="selectUserBusiness(element)"
      >
        <mat-icon>check_circle</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<app-user-business-selection-responsive
  class="responsive-table-mobile"
  [users]="items"
  (selectUserBusiness)="selectUserBusiness($event)"
></app-user-business-selection-responsive>

<p><small><b>Caso o usuário não esteja listado, adicione-o aqui:</b></small></p>
<form
  autocomplete="off"
  fxLayout="row"
  fxLayout.lt-sm="column"
  fxLayoutAlign="start center"
  fxLayoutGap="10px"
  [formGroup]="callUserForm"
  (submit)="onSubmit()"
>
  <mat-form-field appearance="outline" fxFlex="40" color="primary" >
    <mat-label>Informe o Nome:</mat-label>
    <input
      matInput
      placeholder="Nome Usuário"
      autocomplete="off"
      formControlName="name"
    >
  </mat-form-field>

  <mat-form-field appearance="outline" fxFlex="50" color="primary" >
    <mat-label>Informe o Email:</mat-label>
    <input
      matInput
      formControlName="search"
      placeholder="Email de Contato"
      autocomplete="off"
      formControlName="email"
    >
  </mat-form-field>

  <mat-form-field appearance="outline"fxFlex="50" color="primary" >
    <mat-label>Informe o Celular:</mat-label>
    <input
      matInput
      mask="(00)00000-0000"
      placeholder="Numero de Celular"
      autocomplete="off"
      formControlName="mobile"
    >
  </mat-form-field>

  <div class="responsive-table-desktop">
    <button mat-flat-button type="submit" color="primary" style="margin-top: -20px; margin-bottom: 10px;">
      Salvar
    </button>
  </div>

  <div fxFill class="responsive-table-mobile">
    <button fxFill mat-flat-button type="submit" color="primary" style="margin-bottom: 10px;">
      Salvar
    </button>
  </div>
</form>
